<template>
  <div class="vx-row">
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
      :collapse-action="true">
      <div class="vx-row">
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm opacity-100 text-bold">General Search</label>
          <vs-input type="text" v-model="filters['search']" class="w-full mb-4 md:mb-0" />
        </div>
        <div class="w-full vx-col md:w-1/4 sm:w-1/2" v-if="!id">
          <label class="text-sm text-bold">Company</label>
          <v-select :clearable="true" v-model="filters['Company']" :options="company_list" class="w-full"
            label="Name" :reduce="option => option._id">
          </v-select>
        </div>
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm opacity-100 text-bold">Name</label>
          <vs-input type="text" v-model="filters['name']" class="w-full mb-4 md:mb-0" />
        </div>
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm opacity-100 text-bold">Phone</label>
          <vs-input type="text" v-model="filters['phone']" class="w-full mb-4 md:mb-0" />
        </div>
      </div>
      <div class="mt-5 vx-row">
        <div class="w-full ml-auto vx-col">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="filters = {}">CLEAR
          </vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <template slot="actions">
        <div class="flex float-right">
          <div class="con-btns-user flex items-center justify-between">
            <div class="flex mb-4">
              <vs-button v-can="'create-contact'" @click="onClickCreateLocation" class="mr-4" color="primary"
                type="filled">New</vs-button>
              <vs-button v-can="'view-contact'" @click="refreshData" class="mr-0" color="success" type="border"
                icon-pack="feather" icon="icon-rotate-cw"></vs-button>
            </div>
          </div>
        </div>
      </template>
      <div slot="no-body" class="mt-4">

        <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" id="users-list" :data="users_list"
          @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

          <template slot="thead">
            <vs-th width="20%" sort-key="name">Contact Name</vs-th>
            <vs-th width="20%" v-if="!id">Company</vs-th>
            <vs-th width="10%" sort-key="contact_1">Email</vs-th>
            <vs-th width="10%">Phone</vs-th>
            <vs-th width="10%" v-can="'update-contact'">ACTION</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="cursor-pointer" @click.native="onClickUpdate(data[indextr])">


              <vs-td :data="data[indextr].Name">
                {{ data[indextr].Name }}
              </vs-td>

              <vs-td v-if="!id">
                <span v-if="!!data[indextr].Company" @click.stop="onClickOpenCompany(data[indextr].Company._id)" class="cursor-pointer underline">
                  {{ data[indextr].Company.Name }}
                </span>
              </vs-td>

              <vs-td>
                {{ data[indextr].Email || ''}}
              </vs-td>

              <vs-td>
                {{ data[indextr].MobilePhone || '-' }}
              </vs-td>

              <vs-td>
                <div class="vx-row">
                  <vx-tooltip v-can="'update-contact'" class="mr-2" text="Update/View Contact" position="top">
                    <vs-button @click.stop="onClickUpdate(data[indextr])" size="small" color="primary" type="border"
                      icon-pack="feather" icon="icon-eye"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-can="'delete-contact'" class="mr-2" text="Delete Contact" position="top">
                    <vs-button @click.stop="onClickDeleteConfirm(data[indextr]._id)" size="small" color="danger" type="border"
                      icon-pack="feather" icon="icon-trash-2"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>

        </vs-table>
        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.pageSize ? meta.pageSize : 20"
          :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
          description :description-items="descriptionItems" :total="(meta.totalPages) ? meta.totalPages : 0"
          v-model="page" class="p-5">
        </vs-pagination>
      </div>
    </vx-card>
    <CreateObjectPopUp ref="createObjectPopUp" />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const TenantRepository = RepositoryFactory.get('tenant')
const ObjectRepository = RepositoryFactory.get('object')
const DropDownRepository = RepositoryFactory.get('drop_down')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateObjectPopUp from "@/components/popups/general/CreateObjectPopUp.vue"
import { defaultPagination, perPageList } from "@/constants/config";

import vSelect from 'vue-select'

export default {
  name: 'TenantContacts',
  data() {
    return {
      users_list: [],
      company_list: [],
      id: '',
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  async mounted() {
    this.id = this.$route.params.id
    await this.fetchCompanyList()
  },
  components: {
    CreateObjectPopUp,
    'v-select': vSelect,
  },
  methods: {
    async refreshData() {
      await this.fetchUsersList()
    },
    async fetchCompanyList() {
      try {
        const { data } = (await DropDownRepository.fetchObjectsList('account')).data
        this.company_list = data.data
      } catch (e) {
        console.log(e);
      }
    },
    async fetchUsersList() {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = (await TenantRepository.getContactList(this.page, this.filterQuery, this.perPage, this.sort, this.id)).data
        this.users_list = data.data
        this.meta = data.pagination
        this.meta.last_page = Math.ceil(this.meta.totalRecords / this.meta.pageSize)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickCreateLocation() {
      await this.$refs.createObjectPopUp.openPopup('contact', 'create', this.id ? { Company: this.id } : {})
    },
    async onClickUpdate(data) {
      await this.$refs.createObjectPopUp.openPopup('contact', 'update',data)
    },
    async onClickResendEmail(email) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = await TenantRepository.resendTenantStaffUserWelcomeEmail(this.id, email)
        this.showSuccessMessage('Staff user welcome email send successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickDeleteConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        acceptText: 'Delete',
        text: `Are you sure you want to delete this contact?`,
        accept: this.onClickDelete,
        parameters: [ id ]
      })
    },
    async onClickDelete(params) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        await ObjectRepository.deleteObject('contact', params[0])
        this.fetchUsersList()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    filterQueryUpdate() {
      this.fetchUsersList()
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchUsersList()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchUsersList()
      }

    },
    onClickOpenCompany(id) {
      const route = this.$router.resolve({ path: `/pages/companies/${id}` });
      window.open(route.href, '_blank');
    },
  },
  watch: {
    page() {
      this.fetchUsersList()
    },
    perPage() {
      this.fetchUsersList()
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped></style>
